// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/vessels/vessel.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { EmptyRequest } from "../../../common/messages/messages";

export const protobufPackage = "services.transportation.vessels";

export interface OwnershipOperationProtection {
  ownerId?: string | undefined;
  technicalOperatorId?: string | undefined;
  commercialOperatorId?: string | undefined;
  builderId?: string | undefined;
  managerId?: string | undefined;
  protectionIndemnityId?: string | undefined;
}

export interface DimensionsCapacities {
  grt: number;
  nrt: number;
  capacity: number;
  draft: number;
  deadWeight: number;
  loa: number;
  beam: number;
  numberOfTanks?: number | undefined;
  lightShip?: number | undefined;
}

export interface DryDock {
  nextDryDock?: string | undefined;
  lastDryDock?: string | undefined;
}

export interface CharterPartySpeed {
  economicalLadenSpeed: number;
  maximumBallastSpeed: number;
}

export interface Manual {
  manualType: string;
  name: string;
  fileId: string;
}

export interface VesselType {
  name: string;
  code: string;
  description: string;
}

export interface VesselSpec {
  vesselType: string;
  yearBuilt: number;
  dimensionsCapacities: DimensionsCapacities | undefined;
  email?: string | undefined;
  photoIds: string[];
  shipParticularId?: string | undefined;
  ownershipOperationProtection: OwnershipOperationProtection | undefined;
  charterPartySpeed: CharterPartySpeed | undefined;
  dryDock: DryDock | undefined;
  manuals: Manual[];
}

export interface VesselName {
  name: string;
  flag: string;
  from: number;
}

export interface Document {
  documentType: string;
  documentId: string;
  issueDate: number;
  isDeleted?: boolean | undefined;
}

export interface CertificateInfo {
  expirationDate: number;
  issueDate: number;
  fileId?: string | undefined;
}

export interface Certificate {
  name: string;
  abbr: string;
  info: CertificateInfo | undefined;
  history: CertificateInfo[];
}

export interface Vessel {
  imo: string;
  name: VesselName | undefined;
  spec?: VesselSpec | undefined;
  active?: boolean | undefined;
  certificates: Certificate[];
  previousNames: VesselName[];
  documents: Document[];
}

export interface GetAllVesselsResponse {
  vessels: Vessel[];
}

export interface GetVesselByImoRequest {
  vesselImo: string;
}

export interface VesselResponse {
  data: Vessel | undefined;
  version: number;
}

export interface GetActiveVesselsResponse {
  vessels: Vessel[];
}

export interface UpdateVesselReqeust {
  data: Vessel | undefined;
  expectedVersion: number;
}

export interface UpdateVesselCertificateRequest {
  vesselImo: string;
  certificate: Certificate | undefined;
}

function createBaseOwnershipOperationProtection(): OwnershipOperationProtection {
  return {
    ownerId: undefined,
    technicalOperatorId: undefined,
    commercialOperatorId: undefined,
    builderId: undefined,
    managerId: undefined,
    protectionIndemnityId: undefined,
  };
}

export const OwnershipOperationProtection: MessageFns<OwnershipOperationProtection> = {
  encode(message: OwnershipOperationProtection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownerId !== undefined) {
      writer.uint32(10).string(message.ownerId);
    }
    if (message.technicalOperatorId !== undefined) {
      writer.uint32(18).string(message.technicalOperatorId);
    }
    if (message.commercialOperatorId !== undefined) {
      writer.uint32(26).string(message.commercialOperatorId);
    }
    if (message.builderId !== undefined) {
      writer.uint32(34).string(message.builderId);
    }
    if (message.managerId !== undefined) {
      writer.uint32(42).string(message.managerId);
    }
    if (message.protectionIndemnityId !== undefined) {
      writer.uint32(50).string(message.protectionIndemnityId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OwnershipOperationProtection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOwnershipOperationProtection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ownerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.technicalOperatorId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commercialOperatorId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.builderId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.managerId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.protectionIndemnityId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OwnershipOperationProtection {
    return {
      ownerId: isSet(object.ownerId)
        ? globalThis.String(object.ownerId)
        : isSet(object.owner_id)
        ? globalThis.String(object.owner_id)
        : undefined,
      technicalOperatorId: isSet(object.technicalOperatorId)
        ? globalThis.String(object.technicalOperatorId)
        : isSet(object.technical_operator_id)
        ? globalThis.String(object.technical_operator_id)
        : undefined,
      commercialOperatorId: isSet(object.commercialOperatorId)
        ? globalThis.String(object.commercialOperatorId)
        : isSet(object.commercial_operator_id)
        ? globalThis.String(object.commercial_operator_id)
        : undefined,
      builderId: isSet(object.builderId)
        ? globalThis.String(object.builderId)
        : isSet(object.builder_id)
        ? globalThis.String(object.builder_id)
        : undefined,
      managerId: isSet(object.managerId)
        ? globalThis.String(object.managerId)
        : isSet(object.manager_id)
        ? globalThis.String(object.manager_id)
        : undefined,
      protectionIndemnityId: isSet(object.protectionIndemnityId)
        ? globalThis.String(object.protectionIndemnityId)
        : isSet(object.protection_indemnity_id)
        ? globalThis.String(object.protection_indemnity_id)
        : undefined,
    };
  },

  toJSON(message: OwnershipOperationProtection): unknown {
    const obj: any = {};
    if (message.ownerId !== undefined) {
      obj.ownerId = message.ownerId;
    }
    if (message.technicalOperatorId !== undefined) {
      obj.technicalOperatorId = message.technicalOperatorId;
    }
    if (message.commercialOperatorId !== undefined) {
      obj.commercialOperatorId = message.commercialOperatorId;
    }
    if (message.builderId !== undefined) {
      obj.builderId = message.builderId;
    }
    if (message.managerId !== undefined) {
      obj.managerId = message.managerId;
    }
    if (message.protectionIndemnityId !== undefined) {
      obj.protectionIndemnityId = message.protectionIndemnityId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OwnershipOperationProtection>, I>>(base?: I): OwnershipOperationProtection {
    return OwnershipOperationProtection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OwnershipOperationProtection>, I>>(object: I): OwnershipOperationProtection {
    const message = createBaseOwnershipOperationProtection();
    message.ownerId = object.ownerId ?? undefined;
    message.technicalOperatorId = object.technicalOperatorId ?? undefined;
    message.commercialOperatorId = object.commercialOperatorId ?? undefined;
    message.builderId = object.builderId ?? undefined;
    message.managerId = object.managerId ?? undefined;
    message.protectionIndemnityId = object.protectionIndemnityId ?? undefined;
    return message;
  },
};

function createBaseDimensionsCapacities(): DimensionsCapacities {
  return {
    grt: 0,
    nrt: 0,
    capacity: 0,
    draft: 0,
    deadWeight: 0,
    loa: 0,
    beam: 0,
    numberOfTanks: undefined,
    lightShip: undefined,
  };
}

export const DimensionsCapacities: MessageFns<DimensionsCapacities> = {
  encode(message: DimensionsCapacities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.grt !== 0) {
      writer.uint32(9).double(message.grt);
    }
    if (message.nrt !== 0) {
      writer.uint32(17).double(message.nrt);
    }
    if (message.capacity !== 0) {
      writer.uint32(25).double(message.capacity);
    }
    if (message.draft !== 0) {
      writer.uint32(33).double(message.draft);
    }
    if (message.deadWeight !== 0) {
      writer.uint32(41).double(message.deadWeight);
    }
    if (message.loa !== 0) {
      writer.uint32(49).double(message.loa);
    }
    if (message.beam !== 0) {
      writer.uint32(57).double(message.beam);
    }
    if (message.numberOfTanks !== undefined) {
      writer.uint32(64).int32(message.numberOfTanks);
    }
    if (message.lightShip !== undefined) {
      writer.uint32(73).double(message.lightShip);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DimensionsCapacities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDimensionsCapacities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.grt = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.nrt = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.capacity = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.draft = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.deadWeight = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.loa = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.beam = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.numberOfTanks = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.lightShip = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DimensionsCapacities {
    return {
      grt: isSet(object.grt) ? globalThis.Number(object.grt) : 0,
      nrt: isSet(object.nrt) ? globalThis.Number(object.nrt) : 0,
      capacity: isSet(object.capacity) ? globalThis.Number(object.capacity) : 0,
      draft: isSet(object.draft) ? globalThis.Number(object.draft) : 0,
      deadWeight: isSet(object.deadWeight)
        ? globalThis.Number(object.deadWeight)
        : isSet(object.dead_weight)
        ? globalThis.Number(object.dead_weight)
        : 0,
      loa: isSet(object.loa) ? globalThis.Number(object.loa) : 0,
      beam: isSet(object.beam) ? globalThis.Number(object.beam) : 0,
      numberOfTanks: isSet(object.numberOfTanks)
        ? globalThis.Number(object.numberOfTanks)
        : isSet(object.number_of_tanks)
        ? globalThis.Number(object.number_of_tanks)
        : undefined,
      lightShip: isSet(object.lightShip)
        ? globalThis.Number(object.lightShip)
        : isSet(object.light_ship)
        ? globalThis.Number(object.light_ship)
        : undefined,
    };
  },

  toJSON(message: DimensionsCapacities): unknown {
    const obj: any = {};
    if (message.grt !== 0) {
      obj.grt = message.grt;
    }
    if (message.nrt !== 0) {
      obj.nrt = message.nrt;
    }
    if (message.capacity !== 0) {
      obj.capacity = message.capacity;
    }
    if (message.draft !== 0) {
      obj.draft = message.draft;
    }
    if (message.deadWeight !== 0) {
      obj.deadWeight = message.deadWeight;
    }
    if (message.loa !== 0) {
      obj.loa = message.loa;
    }
    if (message.beam !== 0) {
      obj.beam = message.beam;
    }
    if (message.numberOfTanks !== undefined) {
      obj.numberOfTanks = Math.round(message.numberOfTanks);
    }
    if (message.lightShip !== undefined) {
      obj.lightShip = message.lightShip;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DimensionsCapacities>, I>>(base?: I): DimensionsCapacities {
    return DimensionsCapacities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DimensionsCapacities>, I>>(object: I): DimensionsCapacities {
    const message = createBaseDimensionsCapacities();
    message.grt = object.grt ?? 0;
    message.nrt = object.nrt ?? 0;
    message.capacity = object.capacity ?? 0;
    message.draft = object.draft ?? 0;
    message.deadWeight = object.deadWeight ?? 0;
    message.loa = object.loa ?? 0;
    message.beam = object.beam ?? 0;
    message.numberOfTanks = object.numberOfTanks ?? undefined;
    message.lightShip = object.lightShip ?? undefined;
    return message;
  },
};

function createBaseDryDock(): DryDock {
  return { nextDryDock: undefined, lastDryDock: undefined };
}

export const DryDock: MessageFns<DryDock> = {
  encode(message: DryDock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextDryDock !== undefined) {
      writer.uint32(10).string(message.nextDryDock);
    }
    if (message.lastDryDock !== undefined) {
      writer.uint32(18).string(message.lastDryDock);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DryDock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDryDock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextDryDock = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lastDryDock = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DryDock {
    return {
      nextDryDock: isSet(object.nextDryDock)
        ? globalThis.String(object.nextDryDock)
        : isSet(object.next_dry_dock)
        ? globalThis.String(object.next_dry_dock)
        : undefined,
      lastDryDock: isSet(object.lastDryDock)
        ? globalThis.String(object.lastDryDock)
        : isSet(object.last_dry_dock)
        ? globalThis.String(object.last_dry_dock)
        : undefined,
    };
  },

  toJSON(message: DryDock): unknown {
    const obj: any = {};
    if (message.nextDryDock !== undefined) {
      obj.nextDryDock = message.nextDryDock;
    }
    if (message.lastDryDock !== undefined) {
      obj.lastDryDock = message.lastDryDock;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DryDock>, I>>(base?: I): DryDock {
    return DryDock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DryDock>, I>>(object: I): DryDock {
    const message = createBaseDryDock();
    message.nextDryDock = object.nextDryDock ?? undefined;
    message.lastDryDock = object.lastDryDock ?? undefined;
    return message;
  },
};

function createBaseCharterPartySpeed(): CharterPartySpeed {
  return { economicalLadenSpeed: 0, maximumBallastSpeed: 0 };
}

export const CharterPartySpeed: MessageFns<CharterPartySpeed> = {
  encode(message: CharterPartySpeed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.economicalLadenSpeed !== 0) {
      writer.uint32(9).double(message.economicalLadenSpeed);
    }
    if (message.maximumBallastSpeed !== 0) {
      writer.uint32(17).double(message.maximumBallastSpeed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CharterPartySpeed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCharterPartySpeed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.economicalLadenSpeed = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.maximumBallastSpeed = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CharterPartySpeed {
    return {
      economicalLadenSpeed: isSet(object.economicalLadenSpeed)
        ? globalThis.Number(object.economicalLadenSpeed)
        : isSet(object.economical_laden_speed)
        ? globalThis.Number(object.economical_laden_speed)
        : 0,
      maximumBallastSpeed: isSet(object.maximumBallastSpeed)
        ? globalThis.Number(object.maximumBallastSpeed)
        : isSet(object.maximum_ballast_speed)
        ? globalThis.Number(object.maximum_ballast_speed)
        : 0,
    };
  },

  toJSON(message: CharterPartySpeed): unknown {
    const obj: any = {};
    if (message.economicalLadenSpeed !== 0) {
      obj.economicalLadenSpeed = message.economicalLadenSpeed;
    }
    if (message.maximumBallastSpeed !== 0) {
      obj.maximumBallastSpeed = message.maximumBallastSpeed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CharterPartySpeed>, I>>(base?: I): CharterPartySpeed {
    return CharterPartySpeed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CharterPartySpeed>, I>>(object: I): CharterPartySpeed {
    const message = createBaseCharterPartySpeed();
    message.economicalLadenSpeed = object.economicalLadenSpeed ?? 0;
    message.maximumBallastSpeed = object.maximumBallastSpeed ?? 0;
    return message;
  },
};

function createBaseManual(): Manual {
  return { manualType: "", name: "", fileId: "" };
}

export const Manual: MessageFns<Manual> = {
  encode(message: Manual, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.manualType !== "") {
      writer.uint32(10).string(message.manualType);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.fileId !== "") {
      writer.uint32(26).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Manual {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManual();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.manualType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Manual {
    return {
      manualType: isSet(object.manualType)
        ? globalThis.String(object.manualType)
        : isSet(object.manual_type)
        ? globalThis.String(object.manual_type)
        : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: Manual): unknown {
    const obj: any = {};
    if (message.manualType !== "") {
      obj.manualType = message.manualType;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Manual>, I>>(base?: I): Manual {
    return Manual.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Manual>, I>>(object: I): Manual {
    const message = createBaseManual();
    message.manualType = object.manualType ?? "";
    message.name = object.name ?? "";
    message.fileId = object.fileId ?? "";
    return message;
  },
};

function createBaseVesselType(): VesselType {
  return { name: "", code: "", description: "" };
}

export const VesselType: MessageFns<VesselType> = {
  encode(message: VesselType, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselType {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselType {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: VesselType): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselType>, I>>(base?: I): VesselType {
    return VesselType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselType>, I>>(object: I): VesselType {
    const message = createBaseVesselType();
    message.name = object.name ?? "";
    message.code = object.code ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseVesselSpec(): VesselSpec {
  return {
    vesselType: "",
    yearBuilt: 0,
    dimensionsCapacities: undefined,
    email: undefined,
    photoIds: [],
    shipParticularId: undefined,
    ownershipOperationProtection: undefined,
    charterPartySpeed: undefined,
    dryDock: undefined,
    manuals: [],
  };
}

export const VesselSpec: MessageFns<VesselSpec> = {
  encode(message: VesselSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselType !== "") {
      writer.uint32(10).string(message.vesselType);
    }
    if (message.yearBuilt !== 0) {
      writer.uint32(16).int32(message.yearBuilt);
    }
    if (message.dimensionsCapacities !== undefined) {
      DimensionsCapacities.encode(message.dimensionsCapacities, writer.uint32(26).fork()).join();
    }
    if (message.email !== undefined) {
      writer.uint32(34).string(message.email);
    }
    for (const v of message.photoIds) {
      writer.uint32(42).string(v!);
    }
    if (message.shipParticularId !== undefined) {
      writer.uint32(50).string(message.shipParticularId);
    }
    if (message.ownershipOperationProtection !== undefined) {
      OwnershipOperationProtection.encode(message.ownershipOperationProtection, writer.uint32(58).fork()).join();
    }
    if (message.charterPartySpeed !== undefined) {
      CharterPartySpeed.encode(message.charterPartySpeed, writer.uint32(66).fork()).join();
    }
    if (message.dryDock !== undefined) {
      DryDock.encode(message.dryDock, writer.uint32(74).fork()).join();
    }
    for (const v of message.manuals) {
      Manual.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.yearBuilt = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dimensionsCapacities = DimensionsCapacities.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.photoIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.shipParticularId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ownershipOperationProtection = OwnershipOperationProtection.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.charterPartySpeed = CharterPartySpeed.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.dryDock = DryDock.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.manuals.push(Manual.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselSpec {
    return {
      vesselType: isSet(object.vesselType)
        ? globalThis.String(object.vesselType)
        : isSet(object.vessel_type)
        ? globalThis.String(object.vessel_type)
        : "",
      yearBuilt: isSet(object.yearBuilt)
        ? globalThis.Number(object.yearBuilt)
        : isSet(object.year_built)
        ? globalThis.Number(object.year_built)
        : 0,
      dimensionsCapacities: isSet(object.dimensionsCapacities)
        ? DimensionsCapacities.fromJSON(object.dimensionsCapacities)
        : isSet(object.dimensions_capacities)
        ? DimensionsCapacities.fromJSON(object.dimensions_capacities)
        : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      photoIds: globalThis.Array.isArray(object?.photoIds)
        ? object.photoIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.photo_ids)
        ? object.photo_ids.map((e: any) => globalThis.String(e))
        : [],
      shipParticularId: isSet(object.shipParticularId)
        ? globalThis.String(object.shipParticularId)
        : isSet(object.ship_particular_id)
        ? globalThis.String(object.ship_particular_id)
        : undefined,
      ownershipOperationProtection: isSet(object.ownershipOperationProtection)
        ? OwnershipOperationProtection.fromJSON(object.ownershipOperationProtection)
        : isSet(object.ownership_operation_protection)
        ? OwnershipOperationProtection.fromJSON(object.ownership_operation_protection)
        : undefined,
      charterPartySpeed: isSet(object.charterPartySpeed)
        ? CharterPartySpeed.fromJSON(object.charterPartySpeed)
        : isSet(object.charter_party_speed)
        ? CharterPartySpeed.fromJSON(object.charter_party_speed)
        : undefined,
      dryDock: isSet(object.dryDock)
        ? DryDock.fromJSON(object.dryDock)
        : isSet(object.dry_dock)
        ? DryDock.fromJSON(object.dry_dock)
        : undefined,
      manuals: globalThis.Array.isArray(object?.manuals)
        ? object.manuals.map((e: any) => Manual.fromJSON(e))
        : [],
    };
  },

  toJSON(message: VesselSpec): unknown {
    const obj: any = {};
    if (message.vesselType !== "") {
      obj.vesselType = message.vesselType;
    }
    if (message.yearBuilt !== 0) {
      obj.yearBuilt = Math.round(message.yearBuilt);
    }
    if (message.dimensionsCapacities !== undefined) {
      obj.dimensionsCapacities = DimensionsCapacities.toJSON(message.dimensionsCapacities);
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.photoIds?.length) {
      obj.photoIds = message.photoIds;
    }
    if (message.shipParticularId !== undefined) {
      obj.shipParticularId = message.shipParticularId;
    }
    if (message.ownershipOperationProtection !== undefined) {
      obj.ownershipOperationProtection = OwnershipOperationProtection.toJSON(message.ownershipOperationProtection);
    }
    if (message.charterPartySpeed !== undefined) {
      obj.charterPartySpeed = CharterPartySpeed.toJSON(message.charterPartySpeed);
    }
    if (message.dryDock !== undefined) {
      obj.dryDock = DryDock.toJSON(message.dryDock);
    }
    if (message.manuals?.length) {
      obj.manuals = message.manuals.map((e) => Manual.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselSpec>, I>>(base?: I): VesselSpec {
    return VesselSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselSpec>, I>>(object: I): VesselSpec {
    const message = createBaseVesselSpec();
    message.vesselType = object.vesselType ?? "";
    message.yearBuilt = object.yearBuilt ?? 0;
    message.dimensionsCapacities = (object.dimensionsCapacities !== undefined && object.dimensionsCapacities !== null)
      ? DimensionsCapacities.fromPartial(object.dimensionsCapacities)
      : undefined;
    message.email = object.email ?? undefined;
    message.photoIds = object.photoIds?.map((e) => e) || [];
    message.shipParticularId = object.shipParticularId ?? undefined;
    message.ownershipOperationProtection =
      (object.ownershipOperationProtection !== undefined && object.ownershipOperationProtection !== null)
        ? OwnershipOperationProtection.fromPartial(object.ownershipOperationProtection)
        : undefined;
    message.charterPartySpeed = (object.charterPartySpeed !== undefined && object.charterPartySpeed !== null)
      ? CharterPartySpeed.fromPartial(object.charterPartySpeed)
      : undefined;
    message.dryDock = (object.dryDock !== undefined && object.dryDock !== null)
      ? DryDock.fromPartial(object.dryDock)
      : undefined;
    message.manuals = object.manuals?.map((e) => Manual.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVesselName(): VesselName {
  return { name: "", flag: "", from: 0 };
}

export const VesselName: MessageFns<VesselName> = {
  encode(message: VesselName, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.flag !== "") {
      writer.uint32(18).string(message.flag);
    }
    if (message.from !== 0) {
      writer.uint32(24).int64(message.from);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselName {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselName();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.flag = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.from = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselName {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      flag: isSet(object.flag) ? globalThis.String(object.flag) : "",
      from: isSet(object.from) ? globalThis.Number(object.from) : 0,
    };
  },

  toJSON(message: VesselName): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.flag !== "") {
      obj.flag = message.flag;
    }
    if (message.from !== 0) {
      obj.from = Math.round(message.from);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselName>, I>>(base?: I): VesselName {
    return VesselName.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselName>, I>>(object: I): VesselName {
    const message = createBaseVesselName();
    message.name = object.name ?? "";
    message.flag = object.flag ?? "";
    message.from = object.from ?? 0;
    return message;
  },
};

function createBaseDocument(): Document {
  return { documentType: "", documentId: "", issueDate: 0, isDeleted: undefined };
}

export const Document: MessageFns<Document> = {
  encode(message: Document, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentType !== "") {
      writer.uint32(10).string(message.documentType);
    }
    if (message.documentId !== "") {
      writer.uint32(18).string(message.documentId);
    }
    if (message.issueDate !== 0) {
      writer.uint32(24).int64(message.issueDate);
    }
    if (message.isDeleted !== undefined) {
      writer.uint32(32).bool(message.isDeleted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Document {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.issueDate = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Document {
    return {
      documentType: isSet(object.documentType)
        ? globalThis.String(object.documentType)
        : isSet(object.document_type)
        ? globalThis.String(object.document_type)
        : "",
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      issueDate: isSet(object.issueDate)
        ? globalThis.Number(object.issueDate)
        : isSet(object.issue_date)
        ? globalThis.Number(object.issue_date)
        : 0,
      isDeleted: isSet(object.isDeleted)
        ? globalThis.Boolean(object.isDeleted)
        : isSet(object.is_deleted)
        ? globalThis.Boolean(object.is_deleted)
        : undefined,
    };
  },

  toJSON(message: Document): unknown {
    const obj: any = {};
    if (message.documentType !== "") {
      obj.documentType = message.documentType;
    }
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.issueDate !== 0) {
      obj.issueDate = Math.round(message.issueDate);
    }
    if (message.isDeleted !== undefined) {
      obj.isDeleted = message.isDeleted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Document>, I>>(base?: I): Document {
    return Document.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Document>, I>>(object: I): Document {
    const message = createBaseDocument();
    message.documentType = object.documentType ?? "";
    message.documentId = object.documentId ?? "";
    message.issueDate = object.issueDate ?? 0;
    message.isDeleted = object.isDeleted ?? undefined;
    return message;
  },
};

function createBaseCertificateInfo(): CertificateInfo {
  return { expirationDate: 0, issueDate: 0, fileId: undefined };
}

export const CertificateInfo: MessageFns<CertificateInfo> = {
  encode(message: CertificateInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationDate !== 0) {
      writer.uint32(8).int64(message.expirationDate);
    }
    if (message.issueDate !== 0) {
      writer.uint32(16).int64(message.issueDate);
    }
    if (message.fileId !== undefined) {
      writer.uint32(26).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CertificateInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCertificateInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.expirationDate = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.issueDate = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CertificateInfo {
    return {
      expirationDate: isSet(object.expirationDate)
        ? globalThis.Number(object.expirationDate)
        : isSet(object.expiration_date)
        ? globalThis.Number(object.expiration_date)
        : 0,
      issueDate: isSet(object.issueDate)
        ? globalThis.Number(object.issueDate)
        : isSet(object.issue_date)
        ? globalThis.Number(object.issue_date)
        : 0,
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : undefined,
    };
  },

  toJSON(message: CertificateInfo): unknown {
    const obj: any = {};
    if (message.expirationDate !== 0) {
      obj.expirationDate = Math.round(message.expirationDate);
    }
    if (message.issueDate !== 0) {
      obj.issueDate = Math.round(message.issueDate);
    }
    if (message.fileId !== undefined) {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CertificateInfo>, I>>(base?: I): CertificateInfo {
    return CertificateInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CertificateInfo>, I>>(object: I): CertificateInfo {
    const message = createBaseCertificateInfo();
    message.expirationDate = object.expirationDate ?? 0;
    message.issueDate = object.issueDate ?? 0;
    message.fileId = object.fileId ?? undefined;
    return message;
  },
};

function createBaseCertificate(): Certificate {
  return { name: "", abbr: "", info: undefined, history: [] };
}

export const Certificate: MessageFns<Certificate> = {
  encode(message: Certificate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.abbr !== "") {
      writer.uint32(18).string(message.abbr);
    }
    if (message.info !== undefined) {
      CertificateInfo.encode(message.info, writer.uint32(26).fork()).join();
    }
    for (const v of message.history) {
      CertificateInfo.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Certificate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCertificate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.abbr = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info = CertificateInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.history.push(CertificateInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Certificate {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      abbr: isSet(object.abbr) ? globalThis.String(object.abbr) : "",
      info: isSet(object.info) ? CertificateInfo.fromJSON(object.info) : undefined,
      history: globalThis.Array.isArray(object?.history)
        ? object.history.map((e: any) => CertificateInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Certificate): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.abbr !== "") {
      obj.abbr = message.abbr;
    }
    if (message.info !== undefined) {
      obj.info = CertificateInfo.toJSON(message.info);
    }
    if (message.history?.length) {
      obj.history = message.history.map((e) => CertificateInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Certificate>, I>>(base?: I): Certificate {
    return Certificate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Certificate>, I>>(object: I): Certificate {
    const message = createBaseCertificate();
    message.name = object.name ?? "";
    message.abbr = object.abbr ?? "";
    message.info = (object.info !== undefined && object.info !== null)
      ? CertificateInfo.fromPartial(object.info)
      : undefined;
    message.history = object.history?.map((e) => CertificateInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVessel(): Vessel {
  return {
    imo: "",
    name: undefined,
    spec: undefined,
    active: undefined,
    certificates: [],
    previousNames: [],
    documents: [],
  };
}

export const Vessel: MessageFns<Vessel> = {
  encode(message: Vessel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.imo !== "") {
      writer.uint32(10).string(message.imo);
    }
    if (message.name !== undefined) {
      VesselName.encode(message.name, writer.uint32(18).fork()).join();
    }
    if (message.spec !== undefined) {
      VesselSpec.encode(message.spec, writer.uint32(26).fork()).join();
    }
    if (message.active !== undefined) {
      writer.uint32(32).bool(message.active);
    }
    for (const v of message.certificates) {
      Certificate.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.previousNames) {
      VesselName.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.documents) {
      Document.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vessel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVessel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.imo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = VesselName.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.spec = VesselSpec.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.certificates.push(Certificate.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.previousNames.push(VesselName.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.documents.push(Document.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vessel {
    return {
      imo: isSet(object.imo) ? globalThis.String(object.imo) : "",
      name: isSet(object.name) ? VesselName.fromJSON(object.name) : undefined,
      spec: isSet(object.spec) ? VesselSpec.fromJSON(object.spec) : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : undefined,
      certificates: globalThis.Array.isArray(object?.certificates)
        ? object.certificates.map((e: any) => Certificate.fromJSON(e))
        : [],
      previousNames: globalThis.Array.isArray(object?.previousNames)
        ? object.previousNames.map((e: any) => VesselName.fromJSON(e))
        : globalThis.Array.isArray(object?.previous_names)
        ? object.previous_names.map((e: any) => VesselName.fromJSON(e))
        : [],
      documents: globalThis.Array.isArray(object?.documents)
        ? object.documents.map((e: any) => Document.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Vessel): unknown {
    const obj: any = {};
    if (message.imo !== "") {
      obj.imo = message.imo;
    }
    if (message.name !== undefined) {
      obj.name = VesselName.toJSON(message.name);
    }
    if (message.spec !== undefined) {
      obj.spec = VesselSpec.toJSON(message.spec);
    }
    if (message.active !== undefined) {
      obj.active = message.active;
    }
    if (message.certificates?.length) {
      obj.certificates = message.certificates.map((e) => Certificate.toJSON(e));
    }
    if (message.previousNames?.length) {
      obj.previousNames = message.previousNames.map((e) => VesselName.toJSON(e));
    }
    if (message.documents?.length) {
      obj.documents = message.documents.map((e) => Document.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vessel>, I>>(base?: I): Vessel {
    return Vessel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vessel>, I>>(object: I): Vessel {
    const message = createBaseVessel();
    message.imo = object.imo ?? "";
    message.name = (object.name !== undefined && object.name !== null)
      ? VesselName.fromPartial(object.name)
      : undefined;
    message.spec = (object.spec !== undefined && object.spec !== null)
      ? VesselSpec.fromPartial(object.spec)
      : undefined;
    message.active = object.active ?? undefined;
    message.certificates = object.certificates?.map((e) => Certificate.fromPartial(e)) || [];
    message.previousNames = object.previousNames?.map((e) => VesselName.fromPartial(e)) || [];
    message.documents = object.documents?.map((e) => Document.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAllVesselsResponse(): GetAllVesselsResponse {
  return { vessels: [] };
}

export const GetAllVesselsResponse: MessageFns<GetAllVesselsResponse> = {
  encode(message: GetAllVesselsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.vessels) {
      Vessel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllVesselsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllVesselsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vessels.push(Vessel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllVesselsResponse {
    return {
      vessels: globalThis.Array.isArray(object?.vessels) ? object.vessels.map((e: any) => Vessel.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetAllVesselsResponse): unknown {
    const obj: any = {};
    if (message.vessels?.length) {
      obj.vessels = message.vessels.map((e) => Vessel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllVesselsResponse>, I>>(base?: I): GetAllVesselsResponse {
    return GetAllVesselsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllVesselsResponse>, I>>(object: I): GetAllVesselsResponse {
    const message = createBaseGetAllVesselsResponse();
    message.vessels = object.vessels?.map((e) => Vessel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetVesselByImoRequest(): GetVesselByImoRequest {
  return { vesselImo: "" };
}

export const GetVesselByImoRequest: MessageFns<GetVesselByImoRequest> = {
  encode(message: GetVesselByImoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVesselByImoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetVesselByImoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetVesselByImoRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: GetVesselByImoRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetVesselByImoRequest>, I>>(base?: I): GetVesselByImoRequest {
    return GetVesselByImoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetVesselByImoRequest>, I>>(object: I): GetVesselByImoRequest {
    const message = createBaseGetVesselByImoRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseVesselResponse(): VesselResponse {
  return { data: undefined, version: 0 };
}

export const VesselResponse: MessageFns<VesselResponse> = {
  encode(message: VesselResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Vessel.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Vessel.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselResponse {
    return {
      data: isSet(object.data) ? Vessel.fromJSON(object.data) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: VesselResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = Vessel.toJSON(message.data);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselResponse>, I>>(base?: I): VesselResponse {
    return VesselResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselResponse>, I>>(object: I): VesselResponse {
    const message = createBaseVesselResponse();
    message.data = (object.data !== undefined && object.data !== null) ? Vessel.fromPartial(object.data) : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseGetActiveVesselsResponse(): GetActiveVesselsResponse {
  return { vessels: [] };
}

export const GetActiveVesselsResponse: MessageFns<GetActiveVesselsResponse> = {
  encode(message: GetActiveVesselsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.vessels) {
      Vessel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActiveVesselsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveVesselsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vessels.push(Vessel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveVesselsResponse {
    return {
      vessels: globalThis.Array.isArray(object?.vessels) ? object.vessels.map((e: any) => Vessel.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetActiveVesselsResponse): unknown {
    const obj: any = {};
    if (message.vessels?.length) {
      obj.vessels = message.vessels.map((e) => Vessel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActiveVesselsResponse>, I>>(base?: I): GetActiveVesselsResponse {
    return GetActiveVesselsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActiveVesselsResponse>, I>>(object: I): GetActiveVesselsResponse {
    const message = createBaseGetActiveVesselsResponse();
    message.vessels = object.vessels?.map((e) => Vessel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateVesselReqeust(): UpdateVesselReqeust {
  return { data: undefined, expectedVersion: 0 };
}

export const UpdateVesselReqeust: MessageFns<UpdateVesselReqeust> = {
  encode(message: UpdateVesselReqeust, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Vessel.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateVesselReqeust {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVesselReqeust();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Vessel.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateVesselReqeust {
    return {
      data: isSet(object.data) ? Vessel.fromJSON(object.data) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateVesselReqeust): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = Vessel.toJSON(message.data);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVesselReqeust>, I>>(base?: I): UpdateVesselReqeust {
    return UpdateVesselReqeust.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVesselReqeust>, I>>(object: I): UpdateVesselReqeust {
    const message = createBaseUpdateVesselReqeust();
    message.data = (object.data !== undefined && object.data !== null) ? Vessel.fromPartial(object.data) : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseUpdateVesselCertificateRequest(): UpdateVesselCertificateRequest {
  return { vesselImo: "", certificate: undefined };
}

export const UpdateVesselCertificateRequest: MessageFns<UpdateVesselCertificateRequest> = {
  encode(message: UpdateVesselCertificateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.certificate !== undefined) {
      Certificate.encode(message.certificate, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateVesselCertificateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVesselCertificateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.certificate = Certificate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateVesselCertificateRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      certificate: isSet(object.certificate) ? Certificate.fromJSON(object.certificate) : undefined,
    };
  },

  toJSON(message: UpdateVesselCertificateRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.certificate !== undefined) {
      obj.certificate = Certificate.toJSON(message.certificate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVesselCertificateRequest>, I>>(base?: I): UpdateVesselCertificateRequest {
    return UpdateVesselCertificateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVesselCertificateRequest>, I>>(
    object: I,
  ): UpdateVesselCertificateRequest {
    const message = createBaseUpdateVesselCertificateRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.certificate = (object.certificate !== undefined && object.certificate !== null)
      ? Certificate.fromPartial(object.certificate)
      : undefined;
    return message;
  },
};

export interface VesselService {
  getVesselByImo(request: DeepPartial<GetVesselByImoRequest>, metadata?: grpc.Metadata): Promise<VesselResponse>;
  addVessel(request: DeepPartial<Vessel>, metadata?: grpc.Metadata): Promise<VesselResponse>;
  updateVessel(request: DeepPartial<UpdateVesselReqeust>, metadata?: grpc.Metadata): Promise<VesselResponse>;
  updateVesselCertificate(
    request: DeepPartial<UpdateVesselCertificateRequest>,
    metadata?: grpc.Metadata,
  ): Promise<VesselResponse>;
  getAllVessels(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetAllVesselsResponse>;
  getActiveVessels(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetActiveVesselsResponse>;
}

export class VesselServiceClientImpl implements VesselService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getVesselByImo = this.getVesselByImo.bind(this);
    this.addVessel = this.addVessel.bind(this);
    this.updateVessel = this.updateVessel.bind(this);
    this.updateVesselCertificate = this.updateVesselCertificate.bind(this);
    this.getAllVessels = this.getAllVessels.bind(this);
    this.getActiveVessels = this.getActiveVessels.bind(this);
  }

  getVesselByImo(request: DeepPartial<GetVesselByImoRequest>, metadata?: grpc.Metadata): Promise<VesselResponse> {
    return this.rpc.unary(VesselServiceGetVesselByImoDesc, GetVesselByImoRequest.fromPartial(request), metadata);
  }

  addVessel(request: DeepPartial<Vessel>, metadata?: grpc.Metadata): Promise<VesselResponse> {
    return this.rpc.unary(VesselServiceAddVesselDesc, Vessel.fromPartial(request), metadata);
  }

  updateVessel(request: DeepPartial<UpdateVesselReqeust>, metadata?: grpc.Metadata): Promise<VesselResponse> {
    return this.rpc.unary(VesselServiceUpdateVesselDesc, UpdateVesselReqeust.fromPartial(request), metadata);
  }

  updateVesselCertificate(
    request: DeepPartial<UpdateVesselCertificateRequest>,
    metadata?: grpc.Metadata,
  ): Promise<VesselResponse> {
    return this.rpc.unary(
      VesselServiceUpdateVesselCertificateDesc,
      UpdateVesselCertificateRequest.fromPartial(request),
      metadata,
    );
  }

  getAllVessels(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetAllVesselsResponse> {
    return this.rpc.unary(VesselServiceGetAllVesselsDesc, EmptyRequest.fromPartial(request), metadata);
  }

  getActiveVessels(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetActiveVesselsResponse> {
    return this.rpc.unary(VesselServiceGetActiveVesselsDesc, EmptyRequest.fromPartial(request), metadata);
  }
}

export const VesselServiceDesc = { serviceName: "services.transportation.vessels.VesselService" };

export const VesselServiceGetVesselByImoDesc: UnaryMethodDefinitionish = {
  methodName: "GetVesselByImo",
  service: VesselServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetVesselByImoRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VesselResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VesselServiceAddVesselDesc: UnaryMethodDefinitionish = {
  methodName: "AddVessel",
  service: VesselServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return Vessel.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VesselResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VesselServiceUpdateVesselDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateVessel",
  service: VesselServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateVesselReqeust.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VesselResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VesselServiceUpdateVesselCertificateDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateVesselCertificate",
  service: VesselServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateVesselCertificateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VesselResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VesselServiceGetAllVesselsDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllVessels",
  service: VesselServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetAllVesselsResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VesselServiceGetActiveVesselsDesc: UnaryMethodDefinitionish = {
  methodName: "GetActiveVessels",
  service: VesselServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetActiveVesselsResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
